import React, { useEffect, useState } from "react";
import { SPVsList } from "../components/SPVsList/SPVsList";
import ISPV from "../components/SPVsList/ISPV";
import SecondaryMarketService from "@services/SecondaryMarket.service";
import { notification } from "antd";
import Loader from "@appComponents/Loader/Loader";

export const SpvsTab = () => {
  const [spvsLoading, setSpvsLoading] = useState(true);
  const [spvs, setSpvs] = useState<ISPV[]>([]);

  useEffect(() => {
    SecondaryMarketService.getSPVs()
      .then((resp) => {
        setSpvsLoading(false);
        setSpvs(resp.data);
      })
      .catch(() => {
        setSpvsLoading(false);
        notification.error({ message: "Something went wrong." });
      });
  }, []);

  if (spvsLoading) {
    return <Loader />;
  }

  return <SPVsList spvsList={spvs} />;
};
